// src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

// Données SEO par page
export const seoByPage = {
  prestations: {
    title: "Prestations coiffure – Amélie... Paris 15e",
    description:
      "Découvrez toutes les prestations de coiffure proposées par notre salon Amélie... à Paris 15e.",
    canonical: "https://amelieparis15.fr/prestations",
    image: "https://amelieparis15.fr/images/prestations-cover.webp",
  },
  contact: {
    title: "Contact – Salon Amélie Paris 15e",
    description:
      "Prenez rendez-vous ou contactez notre salon de coiffure à Paris 15e.",
    canonical: "https://amelieparis15.fr/contact",
    image: "https://amelieparis15.fr/images/contact-cover.webp",
  },
  galerie: {
    title: "Galerie photos – Salon Amélie Paris 15e",
    description:
      "Découvrez les réalisations coiffure de notre salon Amélie... à Paris 15e : coupes, couleurs, balayages et styles tendance.",
    canonical: "https://amelieparis15.fr/galerie",
    image: "https://amelieparis15.fr/images/galerie-cover.webp",
  },
  equipe: {
    title: "Notre équipe – Salon Amélie Paris 15e",
    description:
      "Faites connaissance avec l’équipe du salon Amélie... à Paris 15e : des coiffeurs passionnés, experts et à l’écoute.",
    canonical: "https://amelieparis15.fr/equipe",
    image: "https://amelieparis15.fr/images/equipe-cover.webp",
  },
  engagements: {
    title: "Nos engagements – Salon Amélie Paris 15e",
    description:
      "Découvrez nos engagements éco-responsables, nos produits naturels et notre démarche bien-être au salon Amélie... à Paris 15e.",
    canonical: "https://amelieparis15.fr/engagements",
    image: "https://amelieparis15.fr/images/engagement-cover.webp",
  },
  // page d'accueil : données par défaut
  home: {
    title: "Amélie... – Salon de coiffure Paris 15e | Naturel & Authentique",
    description:
      "Salon de coiffure à Paris 15e. Ambiance authentique, soins capillaires naturels, coiffure vegan, lissages, massages, effets soleil et bien plus. Produits bio, respectueux de vos cheveux.",
    canonical: "https://amelieparis15.fr",
    image: "https://amelieparis15.fr/cover.webp",
  },
};

const defaultStructuredData = {
  "@context": "https://schema.org",
  "@type": "HairSalon",
  name: "Amélie... – Salon Paris 15e",
  image: "https://amelieparis15.fr/logo.png",
  description:
    "Salon de coiffure, Paris 15e. Soins, vegan, massages, coupe, couleurs, balayages, effets soleil, ambiance authentique et relax.",
  keywords: [
    "salon de coiffure",
    "coiffure femme",
    "coiffure homme",
    "produits naturels",
    "coiffure vegan",
    "effets soleil",
    "couleur personnalisée",
    "massage capillaire",
    "cheveux blonds",
    "cheveux cuivrés",
    "cheveux frisés",
    "coiffure bio",
    "ambiance musique",
    "coiffure authentique",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "57 boulevard de Vaugirard",
    addressLocality: "Paris",
    addressRegion: "Île-de-France",
    postalCode: "75015",
    addressCountry: "FR",
  },
  url: "https://amelieparis15.fr",
  telephone: "+33 1 43 20 84 31",
  priceRange: "€€",
  openingHours:
    "Tu 10:00-19:00, We 10:00-19:00, Th 10:00-20:00, Fr 10:00-19:00, Sa 09:30-18:00",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+33 1 43 20 84 31",
    contactType: "Service client",
  },
  hasMap:
    "https://www.google.com/maps/place/57+Boulevard+de+Vaugirard,+75015+Paris",
};

const SEO = ({
  pageKey = "home",
  title,
  description,
  canonical,
  image,
  keywords = "salon de coiffure, coiffure femme, homme, enfants, couleurs naturelles, lissage Ybera, balayage, soin capillaire, salon éco-responsable, coiffure bio, soins cheveux naturels, couleur personnalisée, coiffage naturel, vegan, authentique, soleil, effets soleil, coupe, massage, boucle, frisette, cheveux blonds, roux, cuivre, ambiance cool, rigolade, musique, professionnels, produits naturels",
  structuredData,
}) => {
  const pageSEO = seoByPage[pageKey] || seoByPage["home"];

  const metaTitle = title || pageSEO.title;
  const metaDescription = description || pageSEO.description;
  const metaCanonical = canonical || pageSEO.canonical;
  const metaImage = image || pageSEO.image;
  const jsonLD = structuredData || defaultStructuredData;

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <link rel="canonical" href={metaCanonical} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Vincent Deliencourt - Digibuddy" />

      {/* Open Graph */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaCanonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Salon Amélie – Paris 15e" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>
    </Helmet>
  );
};

export default SEO;
